import { ApiEmployee, ApiEmployeeLifecycleStatus } from "@/types/employees/employee.types.ts";
import { ApiFilterAbstract } from "@skailer-com/uikit/core";

export interface ApiEmployeeChartItem {
  employee: ApiEmployee;
  direct_subordinates_count: number;
  all_subordinates_count: number;
}

export enum EmployeeNodeMode {
  parent = "parent",
  children = "children",
}

export interface ApiEmployeeChartFilter extends ApiFilterAbstract {
  division_ids?: number[];
  location_ids?: number[];
  employment_type_ids?: number[];
  employment_contract_ids?: number[];
  legal_entity_ids?: number[];
  employee_lifecycle_statuses?: ApiEmployeeLifecycleStatus[];
}
